import { render, staticRenderFns } from "./ShipmentDetailDocuments.vue?vue&type=template&id=41fc701c&"
import script from "./ShipmentDetailDocuments.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports